import axios from 'axios'

const AuthService = {
    login: (param) => {
        return axios.post(
            process.env.REACT_APP_API_ENDPOINT + '/login',
            param
        ).then(response => {
            if (response.data.status === "success") {
                localStorage.setItem("auth", JSON.stringify(response.data))
            }

            return response.data
        })
    },
    getCurrentAuth: () => {
        return localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : []
    },
}

export default AuthService
